module.exports = __webpack_public_path__ + "static/media/planning.de53ea1f.svg";